import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from '../../i18n';

const CyclingHeader = ({ title, onHide }) => {
  const { t } = useTranslation();

  return (
    <Modal.Header closeButton>
      <Modal.Title style={{ color: '#193255' }}>
        {t('activityDetails.detailsOf', { title })}
      </Modal.Title>
    </Modal.Header>
  );
};

export default CyclingHeader;
